import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Product, ProductScope } from '@spartacus/core';
import { BehaviorSubject, filter, map, switchMap, Observable, Subscription } from 'rxjs';
import { ModalService } from '../../../../components/modal-list/modal-list.service';
import { ModalModifyMotorsComponent } from './modal-modify-motors/modal-modify-motors.component';
import { CurrentProductService } from '@spartacus/storefront';
import { isEmpty } from '../../../../core/services/simple-tools';
import { ModifyMotorsService } from './core/modify-motors.service';
import { ProductCheckInventoryService } from '.././product-inventory/product-check-inventory.service';
import { ModifyMotorsURLIFrameRequest } from './core/modify-motors.model';
import { initialStatus } from '../../../.././core/models/request-status.model';
import { CustomActiveCartService } from '../../cart/_core/active-cart.service';
import { AddToCartStateService } from '../add-to-cart/add-to-cart-state.service';

@Component({
  selector: 'modify-motors',
  templateUrl: './modify-motors.component.html',
  styleUrl: './modify-motors.component.scss',
  standalone: false,
})
export class ModifyMotorsComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClass = '';

  product$ = new BehaviorSubject<Product | undefined>(undefined);
  subscription = new Subscription();
  req$ = new BehaviorSubject<ModifyMotorsURLIFrameRequest | undefined>(initialStatus);

  constructor(
    private currentProductService: CurrentProductService,
    private modalService: ModalService,
    private modifyMotorsService: ModifyMotorsService,
    private productCheckInventoryService: ProductCheckInventoryService,
    private activeCartService: CustomActiveCartService,
    private addToCartStateService: AddToCartStateService,
  ) {}

  ngOnInit(): void {
    this.checkProduct();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkProduct() {
    this.subscription.add(
      this.currentProductService
        .getProduct([ProductScope.DETAILS, ProductScope.PRICE])
        .pipe(filter(product => !isEmpty(product)))
        .subscribe(product => {
          this.product$.next(product!);
          this.hostClass = product?.discontinued ? 'd-none product-discontinued' : '';
        }),
    );
  }

  openModal() {
    this.modalService.create({
      id: 'modify-motors-modal',
      title: 'Modify Motor',
      width: 1200,
      component: ModalModifyMotorsComponent,
      data: {
        product: this.product$.value,
      },
    });
  }

  openNewTab() {
    this.getIframeURL().subscribe({
      next: (url: string | URL | undefined) => {
        window.open(url, '_blank');
      },
      error: (err: any) => {
        // eslint-disable-next-line no-console
        console.error('Failed to open new tab:', err);
      },
    });
  }

  getIframeURL(): Observable<string> {
    return this.activeCartService.getActiveCartId().pipe(
      switchMap(cartID => {
        return this.modifyMotorsService.getIframeURL({
          productCode: this.product$.value?.code,
          productQuantity: this.addToCartStateService.getForm().get('quantity')?.value || 1,
          warehouseID: this.productCheckInventoryService.getWarehouseValue()?.warehouseCode || '',
          cartID,
        });
      }),
      map(response => {
        if (response.hasError) {
          throw new Error(response.message || 'Error fetching iframe URL');
        }
        return response.iframeConfigs?.initParams as string;
      }),
    );
  }
}
